import { gql } from "@apollo/client";

export const PAYOUT_2FA_ON_MUTATION = gql(`
    mutation OnPTFA($code: String!, $globalCode: String) {
      onPTFA(tfaCode: $code, global2faCode: $globalCode)
    }
`);
